module.exports = __webpack_public_path__ + "static/media/languageIcon.afca87ef.svg";